export default {
      id: "site-usage",
      viewBox: "0 0 16 20",
      url: __webpack_public_path__ + "icons.svg#site",
      toString: function () {
        return this.url;
      }
    }